import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    flex: 1,
    flexDirection: 'row',
    paddingTop: theme.spacing(0.25),
  },

  gameDetails: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },

  logoContainer: {
    width: theme.spacing(6.25),
    height: theme.spacing(6.25),
    margin: theme.spacing(0, 3.125, 0, 2.125),
  },

  descriptionContainer: {
    alignSelf: 'center',
  },

  logo: {
    width: '100%',
    height: '100%',
  },

  title: {
    '&.MuiTypography-root': {
      fontSize: theme.spacing(3),
      textTransform: 'capitalize',
      fontFamily: '"Bebas Neue"',
      letterSpacing: '0.05em',
      lineHeight: 1,
    },
  },

  description: {
    '&.MuiTypography-root': {
      fontSize: theme.spacing(1.75),
      textTransform: 'capitalize',
      fontWeight: 'bold',
      letterSpacing: '0.002em',
    },
  },
}));
